if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        // TRWS: the default product template uses the rebuilt section; other templates keep the original.
        const sectionName = this.dataset.section || 'pickup-availability';
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=${sectionName}`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.dataset.variantId = variant.id;
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
          document.querySelector('pickup-availability-drawer')?.remove();
        }
      }

      renderError() {
        if (!this.errorHtml) return;
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button')?.addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        document.querySelector('pickup-availability-drawer')?.remove();

        const preview = sectionInnerHTML?.querySelector('pickup-availability-preview');
        if (!preview) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = preview.outerHTML;
        this.setAttribute('available', '');

        // TRWS: shipping-only sizes render no drawer, so only wire it up when it exists.
        const drawer = sectionInnerHTML.querySelector('pickup-availability-drawer');
        if (!drawer) return;

        document.body.appendChild(drawer);
        const colorClassesToApply = (this.dataset.productPageColorScheme || '').split(' ').filter(Boolean);
        colorClassesToApply.forEach((colorClass) => drawer.classList.add(colorClass));

        // TRWS: the rebuilt block opens the drawer from its link only. The legacy section keeps
        // the original behavior (any click on the preview opens it).
        const legacy = (this.dataset.section || '') === 'pickup-availability-legacy';
        const opener = legacy ? this.querySelector('pickup-availability-preview') : this.querySelector('#ShowPickupAvailabilityDrawer');
        if (opener) {
          opener.addEventListener('click', (evt) => {
            evt.stopPropagation();
            document.querySelector('pickup-availability-drawer')?.show(opener);
          });
        }
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button')?.addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}
